module.exports = __webpack_public_path__ + "static/media/tick.1b57602d.gif";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/tick.gif
// module id = 656
// module chunks = 1